<template src="./Bento.html"></template>
<style src="./Bento.scss" lang="scss"></style>

<script>
  import Simple from '@/components/Simple/Simple'
  import vClickOutside from 'v-click-outside'

  /**
   * Bento menu
   * @vue-prop {Object[]} elements An array of bento-tile objects
   * @vue-prop {Object[]} footer An array of footer element objects
   * @vue-data {Boolean} isOpen indicates whether the menu is shown or not
   */
  export default {
    name: 'HpBento',
    props: {
      elements: Array,
      footer: Array
    },
    data () {
      return {
        isOpen: false
      }
    },
    components: {
      'hp-simple': Simple
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    methods: {
      close () {
        this.isOpen = false
      },
      onElementClick (element) {
        this.close()
        this.$emit('change', element)
      },
      checkClicks () {
        let clickCount = 0

        this.$el.querySelector('label')?.addEventListener('click', () => {
          clickCount++

          if (clickCount === 50) {
            this.$el.classList.add('rotate')

            setTimeout(() => {
              this.$el.classList.remove('rotate')
              clickCount = 0
            }, 1000)
          }
        })
      }
    },
    mounted () {
      this.checkClicks()
    }
  }
</script>
